module.exports = __webpack_public_path__ + "img/icon-glosas-2.71af259e.svg";